import React from "react";
import { BASE_URL } from "../../utils/serverContextPath";
import { useTranslation } from "react-i18next";

export default function ConversationHeader({
    request,
    nbMessages = 0
}) {

    const { t } = useTranslation();

    if (!request) return null;

    //------------------------------------------------------
    // Participants
    //------------------------------------------------------

    const sender = request.sender || {};
    const receiver = request.receiver || {};

    const defaultAvatar =
        "https://cdn-icons-png.flaticon.com/512/847/847969.png";

    const senderPhoto =
        sender.photoUrl
            ? `${BASE_URL}userapp/downloadprofile/${sender.id}`
            : defaultAvatar;

    const receiverPhoto =
        receiver.photoUrl
            ? `${BASE_URL}userapp/downloadprofile/${receiver.id}`
            : defaultAvatar;

    //------------------------------------------------------
    // Type consultation
    //------------------------------------------------------

    const consultationType = () => {

        switch (request.consultationType) {

            case "L":
                return t("consultant.types.livestock");

            case "C":
                return t("consultant.types.agriculture");

            default:
                return "-";
        }

    };

    //------------------------------------------------------
    // Date
    //------------------------------------------------------

  const formatDate = (dateString) => {

    if (!dateString) {
        return "-";
    }

    try {

        // 14/07/2026 23:00:00
        const [datePart, timePart] = dateString.split(" ");

        const [day, month, year] = datePart.split("/");

        const [hour, minute, second] = timePart.split(":");

        const date = new Date(
            year,
            month - 1,
            day,
            hour,
            minute,
            second
        );

        return date.toLocaleDateString(
            "fr-FR",
            {
                day: "2-digit",
                month: "long",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit"
            }
        );
    } catch (error) {
        return dateString;
    }

};

    //------------------------------------------------------
    // Etat
    //------------------------------------------------------

    const getEtatColor = () => {

        switch (request.etatRequete) {

            case "N":
                return "bg-primary";

            case "E":
                return "bg-warning text-dark";

            case "T":
                return "bg-success";

            case "R":
                return "bg-danger";

            default:
                return "bg-secondary";

        }

    };

    const getEtatLabel = () => {

        switch (request.etatRequete) {
            case "N":
                return "Nouvelle";
            case "E":
                return "En cours";
            case "T":
                return "Terminée";
            case "R":
                return "Refusée";
            default:
                return request.etatRequete;

        }

    };

    //------------------------------------------------------

    return (

        <div className="card-header bg-white border-bottom">

            {/*====================================================*/}
            {/* Participants                                        */}
            {/*====================================================*/}

            <div className="row align-items-center">

                {/*====================*/}
                {/* Demandeur          */}
                {/*====================*/}

                <div className="col-md-5">
                    <div className="d-flex align-items-center">
                        <img
                            src={senderPhoto}
                            alt={sender.fullName}
                            className="rounded-circle shadow"
                            style={{
                                width: 70,
                                height: 70,
                                objectFit: "cover"
                            }}

                            onError={(e) => {
                                e.target.src = defaultAvatar;
                            }}

                        />

                        <div className="ms-3">

                            <div className="text-success fw-bold">
                                <i className="bi bi-person-fill me-2"></i>
                                {t("consultant.card.requester")}
                            </div>

                            <h5 className="mb-1 fw-bold">
                                {sender.fullName}
                            </h5>
                            <div className="text-muted small">
                                {sender.email}
                            </div>
                            <div className="text-muted small">
                                {sender.phoneNumber}

                            </div>
                        </div>

                    </div>

                </div>

                {/*====================*/}
                {/* Centre             */}
                {/*====================*/}

                <div className="col-md-2 text-center">

                    <i
                        className="bi bi-arrow-left-right text-success"
                        style={{ fontSize: "2rem" }}
                    />

                    <div className="small text-muted mt-2">
                   {t("messageComposer.conversation")}
                    </div>

                </div>

                {/*====================*/}
                {/* Consultant         */}
                {/*====================*/}

                <div className="col-md-5">
                    <div className="d-flex align-items-center justify-content-md-end">
                        <div className="text-md-end me-3">
                            <div className="text-success fw-bold">
                                <i className="bi bi-person-badge-fill me-2"></i>
                               {t("consultant.card.consultant")}


                            </div>
                            <h5 className="mb-1 fw-bold">
                                {receiver.fullName}
                            </h5>
                            <div className="text-muted small">
                                {receiver.email}
                            </div>
                            <div className="text-muted small">
                                {receiver.phoneNumber}
                            </div>
                        </div>
                        <img
                            src={receiverPhoto}
                            alt={receiver.fullName}
                            className="rounded-circle shadow"
                            style={{
                                width: 70,
                                height: 70,
                                objectFit: "cover"
                            }}
                            onError={(e) => {
                                e.target.src = defaultAvatar;
                            }}
                        />
                    </div>
                </div>
            </div>
            <hr />
            {/*====================================================*/}
            {/* Informations de la consultation                     */}
            {/*====================================================*/}

            <div className="row align-items-center">
                <div className="col-lg-6">
                    <h5 className="fw-bold text-success mb-1">
                        {request.consultationObject}
                    </h5>

                    <small className="text-muted">
                        <i className="bi bi-calendar-event me-2"></i>
                        {formatDate(request.dateConsultReq)}
                        
                        

                    </small>
                </div>

                <div className="col-lg-6">
                    <div className="row text-center">
                        <div className="col-4">
                            <div className="fw-bold text-success">
                                {consultationType()}
                            </div>
                            
                        </div>
                        <div className="col-4">
                            <div className="fw-bold">
                                {nbMessages}
                            </div>
                            <small className="text-muted">
                                {t("messageComposer.nmessage")}
                            </small>
                        </div>
                        <div className="col-4">
                            <span className={`badge ${getEtatColor()} fs-6`}>
                                {getEtatLabel()}
                            </span>
                        </div>

                    </div>

                </div>

            </div>

        </div>

    );

}